import { DataBean } from "../DataBean";

export class BankingConciliationData extends DataBean {


    public async getBankingConciliationData(idBankingAccount:any,date:any,bankingLeft:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliation_getBankingConciliationData_Number_java.util.Date_Number", [idBankingAccount,date,bankingLeft]);
    }

    
     public async getBankingConciliationDatawhitid(idBankingConciliation:any,state:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getBankingConciliationData_Number_Number_Number_Number", [idBankingConciliation,state,page,recordsPerPage]);
    }


}